import { render } from "./AddUsersToGroup.vue?vue&type=template&id=64ef3b7c&scoped=true"
import script from "./AddUsersToGroup.vue?vue&type=script&lang=js"
export * from "./AddUsersToGroup.vue?vue&type=script&lang=js"

import "./AddUsersToGroup.vue?vue&type=style&index=0&id=64ef3b7c&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ef3b7c"]])

export default __exports__